// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"16c52105","545":"16c52105","657":"16c52105","706":"9f328201"}[chunkId] + ".chunk.css";
};